import(/* webpackMode: "eager" */ "/app/src/app/welcome/page.tsx");
